import type { QueryKey } from '@tanstack/react-query';

import type { AppState } from '../../../services/appStore';

export const CONTACTS_BY_LINKEDIN_IDS_KEY = 'contactsByLinkedinIds';

export type LinkedinContactsListQueryKey = ReturnType<typeof makeLinkedinContactsListKey>;

export const isLinkedinContactsListQueryKey = (queryKey: QueryKey): queryKey is LinkedinContactsListQueryKey => {
  return [CONTACTS_BY_LINKEDIN_IDS_KEY].includes(queryKey[0] as string);
};

export const makeLinkedinContactsListKey = (appState: AppState) => {
  const { collectedContactsSearchInfo = [] } = appState;
  const linkedinIds = collectedContactsSearchInfo?.map((contact) => contact.linkedinId || contact.linkedinSalesNavId);
  return [CONTACTS_BY_LINKEDIN_IDS_KEY, linkedinIds] as const;
};
